module.exports = __webpack_public_path__ + "5ddaffddaa0aadedffd07f9fdce3cd16.pdf";